import { jsx as _jsx } from "react/jsx-runtime";
import Impression from '../impression/Impression';
export default function withImpression(options) {
  return function (Component) {
    var impression = function impression(props) {
      return _jsx(Impression, Object.assign({}, props, options, {
        children: _jsx(Component, Object.assign({}, props))
      }));
    };

    impression.displayName = 'withImpression';
    return impression;
  };
}